/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import type { Property } from 'csstype';

interface Props {
  /** Couleur de fond du bouton */
  color: Property.Color;
  /** Titre du bouton */
  content?: React.ReactNode;
  /** Si le bouton contient autre chose que du texte */
  children?: React.ReactNode;
}

const ParametreBackground = (props: Props) => {
  const { color, content, children } = props;

  return (
    <div
      data-testid="parameter-button-background"
      style={{
        borderRadius: '50%',
        backgroundColor: color,
        width: '40rem',
        height: '40rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        letterSpacing: 3,
        color: 'white',
      }}
    >
      {content ? <h1>{content}</h1> : children}
    </div>
  );
};

export default ParametreBackground;
